// extracted by mini-css-extract-plugin
export var buttons = "_a1-0";
export var buttonsActive = "_a1-h";
export var cancelConfirm = "_a1-1";
export var closeButton = "_a1-2";
export var column = "_a1-3";
export var container = "_a1-4";
export var detailHeader = "_a1-6";
export var detailTitle = "_a1-7";
export var detailsContent = "_a1-5";
export var header = "_a1-8";
export var headerWithClose = "_a1-9";
export var icon = "_a1-a";
export var infoIcon = "_a1-c";
export var informationContainer = "_a1-b";
export var sideDrawer = "_a1-d";
export var sideDrawerOpen = "_a1-e";
export var stickyFooter = "_a1-f";
export var typeOption = "_a1-g";